import { render, staticRenderFns } from "./addAccountDrawer.vue?vue&type=template&id=1a06746a&scoped=true"
import script from "./addAccountDrawer.vue?vue&type=script&lang=js"
export * from "./addAccountDrawer.vue?vue&type=script&lang=js"
import style0 from "./addAccountDrawer.vue?vue&type=style&index=0&id=1a06746a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06746a",
  null
  
)

export default component.exports